// extracted by mini-css-extract-plugin
export var active = "Hero-module--active--2b71a";
export var core = "Hero-module--core--814b8";
export var fixed = "Hero-module--fixed--3ef0d";
export var hamburger = "Hero-module--hamburger--17c09";
export var title = "Hero-module--title--7de19";